module.exports = __webpack_public_path__ + "img/avatar1.65c6160a.png";